<div
  class="info-notice d-flex p-3"
  [ngClass]="containerClass()"
>
  <ng-icon
    name="matInfo"
    class="font-size-xl info-icon me-2"
  ></ng-icon>

  @if (text()) {
    <span
      [translate]="text()"
      [translateParams]="translateParams()"
    ></span>
  } @else {
    <ng-content></ng-content>
  }
</div>
